/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Deep_TitleInputs */

const en_sorter_deep_title = /** @type {(inputs: Sorter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sort is locale aware, not byte order`)
};

const ko_sorter_deep_title = /** @type {(inputs: Sorter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬은 바이트 순이 아니라 로케일 기준입니다`)
};

const ja_sorter_deep_title = /** @type {(inputs: Sorter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並べ替えはバイト順ではなくロケール基準です`)
};

/**
* | output |
* | --- |
* | "The sort is locale aware, not byte order" |
*
* @param {Sorter_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_deep_title = /** @type {((inputs?: Sorter_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_deep_title(inputs)
	if (locale === "ko") return ko_sorter_deep_title(inputs)
	return ja_sorter_deep_title(inputs)
});